import * as React from "react";
import { useState } from "react";
import { Genome } from "../../api";
import { getQCValue } from "../../utils/genomes";
import { QualityControlSection } from "../quality-control";
import { ReplicateGroup, ReplicateHeader, ReplicateItem } from "../replicate";
import { SelectLotNumber } from "../select-lot-number";

const ExomeQCSection = ({ genome }: { genome: Genome }) => {
  const [lotNumberIndex, setLotNumberIndex] = useState<number>(0);

  const wesSeq = genome.attributes.atcc_metadata?.wes_sequencing;
  if (!wesSeq) {
    return null;
  }

  const lotNumbers = Object.keys(wesSeq.lot_number);
  if (lotNumbers.length === 0) {
    return null;
  }

  const lotNum = lotNumbers[lotNumberIndex];
  const qc = wesSeq.lot_number[lotNum]!.qc_statistics;
  const n = qc.sample_summary.replicate_count;

  const headers: ReplicateHeader[] = [
    { label: "Library Kit", isNumber: false },
    { label: "Reference", isNumber: false },
    { label: "Mean Coverage Targeted Region", isNumber: true },
    { label: "Number of Mapped Reads Targeted Region", isNumber: true },
  ];
  const items: ReplicateItem[] = [];
  for (let i = 0; i < n; ++i) {
    items.push({
      name: (
        <>
          Replicate <em>#{i + 1}</em>
        </>
      ),
      runDate: qc.illumina_metadata.run_date[i] ?? "",
      sampleName: qc.sample_summary.sample_name[i],
      values: [
        qc.illumina_metadata.library_kit,
        getQCValue(qc.sample_summary.references, i),
        getQCValue(qc.input_reads_summary.mean_coverage_targeted_region, i),
        getQCValue(qc.input_reads_summary.number_of_mapped_reads_targeted_region, i),
      ],
    });
  }

  return (
    <QualityControlSection
      header="Whole Exome Quality Control"
      right={
        lotNumbers.length > 1 ? (
          <SelectLotNumber
            lotNumbers={lotNumbers}
            value={lotNumberIndex}
            onChange={setLotNumberIndex}
          />
        ) : undefined
      }
    >
      <ReplicateGroup data={{ headers, items }} />
    </QualityControlSection>
  );
};

export default ExomeQCSection;
